<template>
  <report-layout :available-reports="$parent.availableReports" :openedReport="$parent.openedReport" close-path="/team/reports">
    <template v-slot:header>
      <div v-if="!$parent.loading">
        <h1 class="info-headline mt-3">{{$t(`personal-results:title-${report}`)}}</h1>
        <h5 class="mb-4"><span>{{ $t(`personal-results:description-${report}`) }}</span></h5>
      </div>
    </template>
    <div v-if="teamAnxietyReport">
      <b-row align-v="center" align-h="center" class="mt-4 mb-5">
        <b-col cols="12" md="5" class="mb-3 mb-md-0">
          <h3 class="feedback-title">
            <span>{{ $t(`team-results:${report}-category-title`) }}</span>
          </h3>
        </b-col>
        <b-col cols="12" sm="12" md="5" v-if="teamAnxietyReport.classAnyAnxiety !== undefined">
          <b-row>
            <b-col>
              <div class="overall-score">
                <span class="--value">{{teamAnxietyReport.classAnyAnxiety}}</span>
                <span class="--scale">/{{teamAnxietyReport.respondents}}</span>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="animated-bar">
                <div class="meter" :class="{'activated': true}" :style="{'background': `linear-gradient(90deg, rgba(87,203,60,1) 0%, rgba(215,193,14,1) ${$parent.formatPercent(0.5/(teamAnxietyReport.classAnyAnxiety/teamAnxietyReport.respondents))}, rgba(214,69,69,1) ${$parent.formatPercent(1/(teamAnxietyReport.classAnyAnxiety/teamAnxietyReport.respondents))})`, 'width': $parent.formatPercent(teamAnxietyReport.classAnyAnxiety/teamAnxietyReport.respondents)}"></div>
              </div>
              <p class="tidbit">{{$t('common:updated')}} {{teamAnxietyReport.updatedAt | moment('from')}}.</p>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" sm="12" md="5" v-else>
          <div style="background: #f6f6f6; color: #999; font-size: 0.75rem;" class="p-3 rounded"><icon name="eye-slash" class="mr-2"/> {{ $t('common:data-redacted-for-privacy') }}</div>
        </b-col>
      </b-row>

      <b-row align-v="center" align-h="center" class="mt-4">
        <b-col cols="12" md="5" class="mb-3 mb-md-0">
          <h3 class="feedback-title mt-3">
            <span>{{ $t(`team-results:${report}-distribution-title`) }}</span>
          </h3>
        </b-col>
        <b-col cols="12" sm="12" md="5">
          <bar-chart :items="teamAnxietyItems()"/>
        </b-col>
      </b-row>

      <b-row align-v="center" align-h="left" class="mt-4">
        <b-col cols="12" sm="12" md="10" lg="8" offset-md="1" offset-lg="2">
          <p class="tidbit text-center mt-5">{{$t('work-engagement-snapshot:report-response-info', { individualAnswers: teamAnxietyReport.totalAnswers, respondents: teamAnxietyReport.respondents })}}</p>
          <p style="white-space: pre-line;">
            {{ $t(`team-results:${report}-general-feedback`) }}
          </p>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <b-row align-v="center" align-h="left" class="mt-4">
        <b-col cols="12" sm="12" md="10" lg="8" offset-md="1" offset-lg="2">
          <div style="background: #f6f6f6; color: #999; font-size: 0.75rem;" class="text-center p-3 rounded"><icon name="eye-slash" class="mr-2"/> {{ $t('common:data-redacted-for-privacy') }}</div>
          <p style="white-space: pre-line;">
            {{ $t(`team-results:${report}-general-feedback`) }}
          </p>
        </b-col>
      </b-row>
    </div>
  </report-layout>
</template>
<script>
import BarChart from '../../common/barchart/BarChart'
import ReportLayout from '../../layouts/ReportLayout'
import { mapGetters } from 'vuex'

export default {
  name: 'TeamAnxietyReport',
  data () {
    return {
      report: 'anxiety-gad-7'
    }
  },
  components: {
    BarChart,
    ReportLayout
  },
  async mounted () {
    this.$parent.openedReport = 'anxiety-gad-7'
    this.loadReport()
  },
  methods: {
    loadReport: function () {
      if (!this.teamAnxietyReport) {
        this.$store.dispatch('loadTeamAnxietyReport')
      }
    },
    mapClassColor (category) {
      const colors = {
        NotAtAllOrLow: '#87D475',
        'NotAtAllOrLow+Mild': '#A6CE4F',
        'NotAtAllOrLow+Mild+Moderate': '#BFCA2F',
        Mild: '#BFCA2F',
        'Mild+Moderate': '#D8C40F',
        'Mild+Moderate+Severe': '#D8AB2B',
        Moderate: '#D8AB2B',
        'Moderate+Severe': '#D6934C',
        Severe: '#D47675'
      }
      return colors[category]
    },
    teamAnxietyItems: function () {
      if (this.teamAnxietyReport.classes) {
        return this.teamAnxietyReport.classes.map(c => {
          return {
            title: this.$t('team-results:classification-title-anxiety-gad-7-' + c.label),
            percentage: this.$parent.formatPercent(c.count / this.teamAnxietyReport.respondents),
            color: this.mapClassColor(c.label)
          }
        })
      }
      return null
    }
  },
  computed: {
    ...mapGetters(['teamAnxietyReport'])
  },
  watch: {
    selectedAccount: function () {
      this.loadReport()
    }
  }
}
</script>
